import { render, staticRenderFns } from "./PersonData.vue?vue&type=template&id=fe89d644&scoped=true&"
import script from "./PersonData.vue?vue&type=script&lang=js&"
export * from "./PersonData.vue?vue&type=script&lang=js&"
import style0 from "./PersonData.vue?vue&type=style&index=0&id=fe89d644&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe89d644",
  null
  
)

component.options.__file = "PersonData.vue"
export default component.exports